module.exports = __webpack_public_path__ + "img/phone.653094b3.png";